import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.recommend');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-recommend',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.recommend/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageRecommendComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public profile: any = null;
    public songs: any[] = [];
    public loading: boolean = true;
    public noProfile: boolean = false;
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public songCount: number = 0;
    public catalogCount: number = 0;
    public approvedCount: number = 0;
    public emptyReason: string = '';

    public filters: any = {
        gender: 'all',
        genre: '',
        difficulty: '',
        year_from: '1990',
        year_to: '2030',
        allow_key_shift: true,
        song_type: ''
    };

    public showFilters: boolean = false;

    public genres = [
        { value: '', label: '전체' },
        { value: 'ballad', label: '발라드' },
        { value: 'dance', label: '댄스' },
        { value: 'ost', label: 'OST' },
        { value: 'hiphop', label: '랩/힙합' },
        { value: 'rnb', label: 'R&B' },
        { value: 'indie', label: '인디' },
        { value: 'trot', label: '트로트' },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.load(true);
    }

    public async load(reset: boolean = true) {
        if (this.loading && !reset) return;
        if (reset) {
            this.page = 1;
            this.songs = [];
        }
        this.loading = true;
        await this.service.render();

        try {
            let { code, data } = await wiz.call("load", {
                ...this.filters,
                page: this.page,
                dump: this.dump
            });
            if (code === 200) {
                this.profile = data.profile;
                const nextSongs = data.songs || [];
                this.songs = reset ? nextSongs : [...this.songs, ...nextSongs];
                this.noProfile = !data.profile;
                this.total = data.total || 0;
                this.songCount = data.song_count || 0;
                this.catalogCount = data.catalog_count || 0;
                this.approvedCount = data.approved_count || this.songCount;
                this.emptyReason = data.empty_reason || '';
            }
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async applyFilters() {
        this.showFilters = false;
        await this.load(true);
    }

    public async resetFilters() {
        this.filters = {
            gender: 'all',
            genre: '',
            difficulty: '',
            year_from: '1990',
            year_to: '2030',
            allow_key_shift: true,
            song_type: ''
        };
        this.showFilters = false;
        await this.load(true);
    }

    public async loadMore() {
        if (this.loading || this.songs.length >= this.total) return;
        this.page++;
        await this.load(false);
    }

    public toggleFilters() {
        this.showFilters = !this.showFilters;
        this.service.render();
    }

    public getKeyShiftText(shift: number): string {
        if (shift === 0) return '원키';
        return shift > 0 ? `+${shift}` : `${shift}`;
    }

    public goSong(id: string) {
        this.service.href('/song/' + id);
    }

    public goTest() {
        this.service.href('/test/measure');
    }

    public goAdminSongs() {
        this.service.href('/admin/songs');
    }

    public getEmptyTitle(): string {
        if (this.emptyReason === 'no_catalog' || this.emptyReason === 'no_songs') return '추천할 곡 데이터가 아직 없습니다';
        if (this.emptyReason === 'no_approved') return '승인된 곡이 아직 없습니다';
        return '조건에 맞는 곡이 없습니다';
    }

    public getEmptyHint(): string {
        if (this.emptyReason === 'no_catalog' || this.emptyReason === 'no_songs') return '관리자가 곡을 등록하면 내 음역에 맞춰 추천할 수 있습니다.';
        if (this.emptyReason === 'no_approved') return '등록된 곡을 승인하면 추천에 표시됩니다.';
        return '필터를 줄이거나 키 조정을 허용하면 더 많은 곡을 볼 수 있습니다.';
    }

    public showAdminSongAction(): boolean {
        return this.emptyReason === 'no_catalog' || this.emptyReason === 'no_approved' || this.emptyReason === 'no_songs';
    }
}

export default PageRecommendComponent;